module.exports = __webpack_public_path__ + "static/img/wordbg.07def68.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/wordbg.jpg
// module id = zsLr
// module chunks = 1